'use strict';

/*
 * This module configures the default material-design theme for the wizard and admin app
 */

angular.module('md-theme', []);
